// web/src/components/DataTable.tsx — desktop <table>, reflows to cards <768px (D05: tables→cards).
// mobileCard is REQUIRED so there is never horizontal overflow on phones.
import type { ReactNode } from 'react';

export function DataTable<T>({ rows, columns, rowKey, onRowClick, mobileCard }: {
  rows: T[];
  columns: { key: string; header: string; render?(r: T): ReactNode }[];
  rowKey(r: T): string;
  onRowClick?(r: T): void;
  mobileCard(r: T): ReactNode;
}) {
  return (
    <>
      {/* Mobile: cards */}
      <div className="flex flex-col gap-3 md:hidden">
        {rows.map((r) => (
          <div key={rowKey(r)} onClick={() => onRowClick?.(r)} className={onRowClick ? 'cursor-pointer' : ''}>
            {mobileCard(r)}
          </div>
        ))}
      </div>
      {/* Desktop: table */}
      <div className="hidden overflow-hidden rounded-lg border border-hair md:block">
        <table className="w-full text-left text-sm">
          <thead className="bg-surface text-muted">
            <tr>{columns.map((c) => <th key={c.key} className="px-4 py-3 font-medium">{c.header}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={rowKey(r)} onClick={() => onRowClick?.(r)}
                className={`border-t border-hair ${onRowClick ? 'cursor-pointer hover:bg-surface/60' : ''}`}>
                {columns.map((c) => <td key={c.key} className="px-4 py-3 text-ink">{c.render ? c.render(r) : String((r as Record<string, unknown>)[c.key] ?? '')}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
